import React from "react";
import * as S from "./emotion";
import { Button, Column, hoverScrollCss, Row } from "@/frameworks/designStuff";

const CreateGroupLayout = ({ children, handleClose }: { children: React.ReactNode; handleClose: () => void }) => {
	return (
		<S.NewGroupSpaceWrapper css={hoverScrollCss} horizonAlign="center">
			<Row css={{ width: "100%", marginRight: 24, marginTop: 60 }} horizonAlign="right">
				<Button.Icon name="Close24" size="XXXlarge" variant="text" onClick={handleClose} />
			</Row>
			<Column style={{ height: "800px", width: "100%", marginTop: "6px" }} horizonAlign="center">
				{children}
			</Column>
		</S.NewGroupSpaceWrapper>
	);
};

export default CreateGroupLayout;
